<div [ngClass]="!mode ? 'example-wrapper' : 'outer-example-wrapper'">
  <div class="vip-process-example" [ngClass]="{ standalone: template?.placementMode === 'standalone' }">
    <div class="container">
      <div class="row">
        @if (!hideCheckbox) {
          <pdq-checkbox [disabled]="true" [checked]="markAsChecked"></pdq-checkbox>
        }
        @if (productImageBase64) {
          <img [src]="productImageBase64" />
        }
        <div class="column">
          <div class="title weight-500">
            {{ title }}
            @if (template.tooltipEnabled) {
              <pdq-icon [style.cursor]="'pointer'" icon="attention" (click)="handleTooltipClick()"></pdq-icon>
            }
            @if (
              template?.timerConfiguration?.enableCountdownTimer === true &&
              template.timerConfiguration.placement === TIMER_PLACEMENTS.BADGE &&
              !isTimerMessageEmpty()
            ) {
              <span class="timer-badge" [ngClass]="getTimerBadgeClass()">
                <span class="timer-icon"></span>
                <span [innerHTML]="getTimerBadgeText() | safe: 'html'"></span>
              </span>
            }
          </div>
          <div class="description">{{ description }}</div>
          @if (
            template?.timerConfiguration?.enableCountdownTimer === true &&
            template.timerConfiguration.placement === TIMER_PLACEMENTS.IN_ITEM_DESCRIPTION &&
            !isTimerMessageEmpty()
          ) {
            <div class="timer-message" [ngClass]="getTimerMessageClass()">
              <span class="timer-icon"></span>
              <span class="timer-message-text" [innerHTML]="getTimerMessageText() | safe: 'html'"></span>
            </div>
          }
          @if (
            template?.timerConfiguration?.enableCountdownTimer === true &&
            template.timerConfiguration.placement === TIMER_PLACEMENTS.INLINE_BAR &&
            !isTimerMessageEmpty()
          ) {
            <div class="timer-bar" [ngClass]="[getTimerBarClass(), 'timer-bar-align-' + getTimerBarAlignment()]">
              <pdq-icon [icon]="getTimerBarBannerIcon()"></pdq-icon>
              <span [innerHTML]="getTimerBarText() | safe: 'html'"></span>
            </div>
          }
        </div>
      </div>

      <div class="price">
        @if (applyDiscountToSubTotal) {
          <div class="discount">
            {{ checkoutExampleService.orderSubtotal() + +upsellRate | currency: currency : 'symbol' }}
          </div>
          <div class="upsellRate weight-500">{{ discount | currency: currency : 'symbol' }}</div>
        } @else {
          @if (+discount > 0) {
            <div class="discount">{{ currency }}{{ discount }}</div>
          }
          <div class="upsellRate weight-500">
            @if (+upsellRate > 0) {
              {{ currency }}{{ upsellRate }}
            } @else {
              Free
            }
          </div>
        }
      </div>
    </div>
    @if (template?.trustSignals?.enabled && template?.trustSignals?.items?.length) {
      <div
        class="trust-signals"
        [ngClass]="template.trustSignals.layout === 'horizontal' ? 'trust-signals--inline' : 'trust-signals--block'">
        @for (item of template.trustSignals.items; track $index) {
          <div class="trust-signals__item" [ngStyle]="trustBadgeStyle">
            @if (item.icon) {
              <pdq-icon [icon]="item.icon" size="small"></pdq-icon>
            }
            <span [innerHTML]="item.richText | safe: 'html'"></span>
          </div>
        }
      </div>
    }
  </div>
</div>
